// source: imports/purchase/product_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

var imports_options_event_metadata_pb =
    require('../../imports/options/event_metadata_pb.js');
goog.object.extend(proto, imports_options_event_metadata_pb);
goog.exportSymbol(
    'proto.com.chegg.rio.edge.purchase.ProductType', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.edge.purchase.ProductType = {
  UNKNOWN_PRODUCTTYPE: 0,
  BUY_USED: 1,
  BUY_NEW: 2,
  RENT: 3,
  RWYW: 4,
  CHEGG_STUDY_SUBSCRIPTION: 5,
  CHEGG_STUDY_ORDER_CONFIRM: 6,
  CHEGG_MATH_SUBSCRIPTION: 7,
  TUTORS_TRIAL: 8,
  CHEGG_STUDY_TRIAL: 9,
  DIGITAL_ACCESS_CODES: 10,
  THREE_BT_UPGRADE: 11,
  ONE_BT_UPGRADE: 12,
  THREE_B_SIGNUP: 13,
  THREE_BT_SIGNUP: 14,
  TWO_BT_UPGRADE: 15,
  THREE_B_SWAP: 16,
  FOUR_B_SIGNUP: 17,
  GRE_PREP_KAPLAN_FOR_CHEGG: 18,
  SAT_PREP_KAPLAN_FOR_CHEGG: 19,
  GMAT_PREP_PREMIUM_KAPLAN_FOR_CHEGG: 20,
  GMAT_PREP_KAPLAN_FOR_CHEGG: 21,
  SAT_PREP_PREMIUM_KAPLAN_FOR_CHEGG: 22,
  EXTEND: 23,
  GRE_PREP_PREMIUM_KAPLAN_FOR_CHEGG: 24,
  PRO_MOTHLY_SIX_NINETYNINE: 25,
  MONTH: 26,
  MONTHLY_PLUS: 27,
  MONTHLY_PLUS_TRIAL: 28,
  SELL: 29,
  PURCHASE: 30,
  LATE_FEE: 31,
  CUL: 32,
  RENT_PRIOR: 33,
  RENT_E_TEXTBOOK: 34,
  TBS: 35,
  SELL_SL_USED: 36,
  E_BOOK_MONTHLY: 37,
  RENT_JIT: 38,
  SELL_JIT_NEW: 39,
  SELL_DAC: 40,
  SELL_JIT_USED: 41,
  SELL_E_TEXTBOOK: 42,
  PHYSICAL_SELL: 43,
  PHYSICAL_RENT: 44,
  E_TEXTBOOK: 45,
  MATHWAY_SUBSCRIPTION: 46,
  CHEGG_STUDY_PACK: 47
};

goog.object.extend(exports, proto.com.chegg.rio.edge.purchase);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/purchase/product_type_pb.js
// module id = 1450
// module chunks = 11